// ============================================================
// پیام تأیید ناوبری
//
// مشکل: پیام SweetAlert با عوض شدن صفحه از بین می‌رود. در این
// برنامه Layout با هر تغییر مسیر دوباره mount می‌شود، پس اگر پیام
// را قبل از navigate باز کنیم، کاربر یا نمی‌بیندش یا نصفه می‌بیند.
//
// راه‌حل همان الگوی NavToast است: متن در sessionStorage گذاشته
// می‌شود و صفحه‌ی مقصد بعد از mount آن را نشان می‌دهد.
// ============================================================

const KEY = "havir-assistant-nav-toast";

/** متن را برای نمایش در صفحه‌ی مقصد می‌گذارد. */
export const queueNavToast = (title: string, text?: string): void => {
    try {
        sessionStorage.setItem(KEY, JSON.stringify({ title, text: text || "" }));
    } catch {
        /* حالت خصوصی مرورگر — پیام حذف می‌شود، ناوبری سالم است */
    }
};

/**
 * پیام را نشان می‌دهد و ۲ ثانیه بعد خودش بسته می‌شود.
 *
 * SweetAlert2 با CSS خودش حدود ۷۰ کیلوبایت است؛ با import() پویا
 * فقط لحظه‌ای بارگذاری می‌شود که واقعاً کاری انجام شده.
 */
export const showNavToast = async (title: string, text?: string): Promise<void> => {
    try {
        const Swal = (await import("sweetalert2")).default;
        Swal.fire({
            title,
            text: text || undefined,
            icon: "success",
            position: "center",
            timer: 2000,
            timerProgressBar: true,
            showConfirmButton: false,
            allowOutsideClick: true,
            // SweetAlert جهت را از صفحه نمی‌خواند؛ صریح ست می‌شود
            didOpen: (element) => {
                element.setAttribute("dir", "rtl");
            },
        });
    } catch {
        /* اگر SweetAlert بارگذاری نشد، ناوبری نباید بشکند */
    }
};

/** اگر پیامی در نوبت بود، نشانش می‌دهد و از نوبت برمی‌دارد. */
export const flushNavToast = (): void => {
    let raw: string | null = null;
    try {
        raw = sessionStorage.getItem(KEY);
        if (raw) sessionStorage.removeItem(KEY);
    } catch {
        return;
    }
    if (!raw) return;

    try {
        const payload = JSON.parse(raw);
        showNavToast(String(payload.title || ""), String(payload.text || ""));
    } catch {
        /* محتوای خراب — نادیده */
    }
};
